import React, {ReactElement} from 'react';
import {Redirect} from 'react-router';
import {useAppSelector, useShouldForwardToPDP} from '../../hooks';
import {useGetStoreProductsQuery} from '../../api/storesApi';
import StoreProductsListing from '../../components/StoreProductsListing';
import PlaceholderProductsListing from '../../components/StoreProductsListing/PlaceholderProductsListing';
import StoreBanner from '../../components/StoreBanner';
import StoreHeader from '../../components/StoreHeader';
import StoreFooter from '../../components/StoreFooter';
import './index.scss';

export interface Props {
  storeSlug: string;
  preview?: boolean;
}

const StoreLayout: React.FC<Props> = ({
  storeSlug,
  preview
}: Props): ReactElement => {
  useGetStoreProductsQuery(storeSlug);
  const storeProducts = useAppSelector(state => state.stores.storeProducts);
  const shouldForwardToPDP = useShouldForwardToPDP() && !preview;
  const shouldShowPlaceholder = !storeProducts?.length && preview;

  return shouldForwardToPDP ? (
    <Redirect to={`/${storeSlug}/products/${storeProducts[0].id}`} />
  ) : (
    <div
      className={`store-layout${
        preview ? ' store-layout-noninteractive' : ''
      }`}>
      <StoreHeader storeSlug={storeSlug} preview={preview} />
      <div className="store-layout-body">
        <StoreBanner storeSlug={storeSlug} />
        {shouldShowPlaceholder ? (
          <PlaceholderProductsListing numCol={3} />
        ) : (
          <StoreProductsListing storeSlug={storeSlug} />
        )}
      </div>

      <StoreFooter storeSlug={storeSlug} preview={preview} />
    </div>
  );
};

StoreLayout.defaultProps = {
  preview: false
};

export default StoreLayout;
